import { Faceplate } from 'common/api/misc';
import { emptyProduct, Product } from 'common/api/e-comm/models/Product';
import { noop } from 'common/utils';
import { scrollToElement } from 'common/utils/utils';
import React, { useContext, useEffect, useRef } from 'react';
import { GiftDetails } from './GiftDetails';
import { GiftDetailsEditForm } from './GiftDetailsEditForm';

interface ProductGiftDetailsProps {
    selectedDate: Date | undefined;
    setSelectedDate: (date: Date | undefined) => void;
    formData: GiftDetailsRequest;
    setFormData: (formData: GiftDetailsRequest) => void;
    hasFormData: boolean;
    setHasFormData: (state: boolean) => unknown;
    isEditing: boolean;
    setIsEditing: (state: boolean) => unknown;
    product: Product;
    sendAsGift: boolean;
    setSendAsGift: (state: boolean) => unknown;
    showEditForm: boolean;
    showGiftDetails: boolean;
    giftCardImages: Faceplate[];
    giftCardImageUrl: string;
}

export interface GiftDetailsRequest {
    SelectedDate: Date | undefined;
    RecipientName: string;
    RecipientEmail: string;
    GiftMessage: string;
    SelectedCardCoverImage: string;
    SenderName: string;
    SenderPhone: string;
}

export const emptyGiftDetailsRequest: GiftDetailsRequest = {
    SelectedDate: new Date(),
    RecipientName: '',
    RecipientEmail: '',
    GiftMessage: '',
    SelectedCardCoverImage: '',
    SenderName: '',
    SenderPhone: '',
};

export const ProductGiftDetailsContext = React.createContext<ProductGiftDetailsProps>({
    selectedDate: undefined,
    setSelectedDate: noop,
    giftCardImages: [],
    formData: emptyGiftDetailsRequest,
    hasFormData: false,
    setHasFormData: noop,
    setFormData: noop,
    isEditing: false,
    setIsEditing: noop,
    product: emptyProduct,
    sendAsGift: false,
    setSendAsGift: noop,
    showEditForm: false,
    showGiftDetails: false,
    giftCardImageUrl: '',
});

export const ProductGiftDetails = () => {
    const { showEditForm, showGiftDetails, sendAsGift } = useContext(ProductGiftDetailsContext);
    const refContainer = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!refContainer.current) {
            return;
        }

        if (showEditForm || showGiftDetails) {
            scrollToElement(refContainer.current);
        }
    }, [showEditForm, showGiftDetails]);

    useEffect(() => {
        if (!sendAsGift) {
            scrollToElement(document.body);
        }
    }, [sendAsGift]);

    return (
        <div ref={refContainer}>
            {showEditForm && <GiftDetailsEditForm />}
            {showGiftDetails && <GiftDetails />}
        </div>
    );
};
